module.exports = __webpack_public_path__ + "static/compound_interest_graph-fa3c6d6636e8a4d8f1eaf28fc23671f3.png";